import Footer from "../../components/Footer";
import Navbar from "../../components/Navbar";
import Introduction from "../../components/Introduction";
import { useAuthContext } from "../../context/AuthContext";
import "./ClassesDetailPage.css";
import Login from "../../components/Login";
import useFetchAuth from "../../hooks/useFetchAuth";
import config from "../../config";
import DefaultPage from "../DefaultPage/DefaultPage";
import Loader from "../../components/Loader";
import { getToken } from "../../helpers";
import { useParams } from "react-router-dom";
import { BlocksRenderer } from "@strapi/blocks-react-renderer";
import Document from "../DocumentsPage/Document.js";
import { useState } from "react";
import Lightbox from "yet-another-react-lightbox";
import "yet-another-react-lightbox/styles.css";
import {
  Download,
  Fullscreen,
  Thumbnails,
  Video,
} from "yet-another-react-lightbox/plugins";
import "yet-another-react-lightbox/plugins/thumbnails.css";

const ClassesPage = () => {
  const { user } = useAuthContext();
  const token = getToken();
  const params = useParams();
  const { id } = params;
  // index pro sledovani lightboxu
  const [index, setIndex] = useState(-1);
  // fetch dat - populate pro získání atributů z bloku kontaktu (contactDetail) a populate pro získání jmen z relace (contacts)
  const { data, loading, error } = useFetchAuth(
    `${config.api}/api/class-pages/${id}`,
    token
  );

  // možné stavy při/po fetchi
  if (loading && token !== null) return <Loader />;
  if (error) return <DefaultPage message="Chyba při načítání třídní stránky" />;

  if (!user) {
    window.location.href = "/tridy";
  }

  if (!data || !data.data) return <DefaultPage message="Žádná data" />;

  //vytvoreni noveho pole pro media z duvodu, ze lightbox potrebuje jiny format JSONU nez jaky dostaneme ze strapi
  //kontrola zdali jsou tam data - jelikoz pole medii je nepovinne
  const galleryData = data?.data[0]?.photos ?? [];
  const mediaEdited = [];

  for (let i = 0; i < galleryData.length; i++) {
    const item = galleryData[i];
    // kontrola nejdulezitejsich hodnot kdyby nahodou byl null
    const mime = item?.mime ?? "";
    const url = item?.url ?? "";
    const mediumUrl = item?.formats?.medium?.url ?? "";
    if (mime.startsWith("image")) {
      mediaEdited.push({
        id: item.id,
        type: "image",
        alternativeText: item.alternativeText,
        src: `${config.api}${url}`,
        medium: `${config.api}${mediumUrl}`,
      });
    } else if (mime.startsWith("video")) {
      mediaEdited.push({
        id: item.id,
        type: "video",
        alternativeText: item.alternativeText,
        title: item.title || "Video Title",
        description: item.description || "Video Description",
        width: 1280, // Adjust as needed
        height: 720, // Adjust as needed
        poster: `/images/video-icon.png`, // default poster
        sources: [
          {
            src: `${config.api}${url}`,
            type: mime,
          },
        ],
      });
    }
  }

  //? test na data z fetche
  //? console.log(id);
  //?console.log(data.data[0]);
  //?console.log(user);
  //? console.log(token);

  //změna titulku stránky v prohlížeči
  document.title = "Třída stranka detail";

  return (
    <div className="min-height-100 d-flex flex-column container-fluid background-white">
      <Navbar />
      <Introduction title="Třídní stránka" text="" />
      <div className="container container-background p-4 p-md-5">
        {!user ? (
          <Login />
        ) : (
          <div>
            <h1>{data.data[0].name}</h1>
            {/* kontrola jestli je text array a jestli neni null */}
            <BlocksRenderer
              content={
                Array.isArray(data?.data[0]?.text) ? data.data[0].text : []
              }
              blocks={{
                image: ({ image }) => (
                  <img
                    src={image.url}
                    alt={image.alternativeText}
                    className="blocks-renderer-img"
                  />
                ),
                list: ({ children, format }) =>
                  format === "unordered" ? (
                    <ul className="blocks-renderer-ul">{children}</ul>
                  ) : (
                    <ol className="blocks-renderer-ol">{children}</ol>
                  ),
              }}
            ></BlocksRenderer>
            <Lightbox
              plugins={[Download, Fullscreen, Thumbnails, Video]}
              open={index >= 0}
              close={() => setIndex(-1)}
              index={index}
              slides={mediaEdited}
            />
            {/* vykreslovani medii podle toho jestli to je video nebo obrazek, na videu nastaven defaultni nahled */}
            <div className="container d-flex flex-wrap justify-content-center">
              {mediaEdited.map((media, index) => (
                <div
                  key={index}
                  className="m-2 col-10 col-md-3 d-flex justify-content-center"
                >
                  {media.type === "image" ? (
                    <img
                      src={media.src}
                      onClick={() => setIndex(index)}
                      alt={media.alternativeText}
                      className="media-thumbnail media-gallery"
                      style={{ cursor: "pointer" }}
                    />
                  ) : (
                    <img
                      src="/images/video-icon.png"
                      onClick={() => setIndex(index)}
                      alt={media.alternativeText}
                      className="media-thumbnail media-gallery"
                      style={{ cursor: "pointer" }}
                    />
                  )}
                </div>
              ))}
            </div>
            {data.data[0].files !== null && (
              <>
                <h3 className="mt-5">Ke stažení</h3>
                <div className="news-doc-container">
                  {data.data[0].files.map((doc) => (
                    <div key={doc.documentId} className="news-doc">
                      <Document name={doc.name} fileUrl={doc.url} />
                    </div>
                  ))}
                </div>
              </>
            )}
          </div>
        )}
      </div>
      <Footer />
    </div>
  );
};
export default ClassesPage;
